// extracted by mini-css-extract-plugin
module.exports = {"guide":"_2wD9b","awaitCon":"_3kBkd","loadingBox":"_1kvXw","loading":"bLfwq","avatarWrapper":"_3VmEX"};